import React from "react";
import MoreButton from "./MoreButton";

const FeatureHead = () => {
    return (
        <div className="relative overflow-hidden bg-white">
            <div className="pt-16 pb-16 sm:pt-24 sm:pb-40 lg:pt-40 lg:pb-48">
                <div className="relative mx-auto max-w-7xl px-5 sm:static sm:px-10 lg:px-8">
                    <div className="sm:max-w-lg">
                        <h1 className="text-h1 font-bold tracking-tight text-gray-900">
                            세일즈포스 <br/>
                            디지털 트렌스포메이션
                        </h1>
                        <p className="mt-4 font-bold text-brand text-h3">
                            영업 관리 시스템CRM, 사용자 경험CX, 디지털
                            마케팅,디지털 커머스
                        </p>
                        <p className="mt-4 text-gray-500 text-body">
                            &quot;Salesforce는 세계 최고의 고객 관계 관리CRM
                            플랫폼입니다. 판매, 서비스, 마케팅을 비롯한 
                            고객 데이터를 하나의 통합된 플랫폼에서 활용하게끔
                            하며 KUSRC에서 CRM으로 활용하는
                            노하우를 기반으로 고객의 요구 사항을 이해하고 문제를
                            해결하는 솔루션을 제공해드립니다.&quot;
                        </p>
                    </div>
                    <div>
                        <div className="mt-7 flex flex-col-reverse items-start gap-10 sm:block">
                            <div
                                aria-hidden="true"
                                className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl"
                            >
                                <div className="relative max-w-sm transform sm:absolute sm:max-w-none sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2
                                lg:-translate-y-1/2 lg:translate-x-8">
                                    <div className="grid grid-cols-3 items-center gap-2 sm:flex sm:gap-6 lg:gap-8">
                                        <div className="grid flex-shrink-0 grid-cols-1 gap-y-2 sm:gap-y-6 lg:gap-y-8">
                                            <div className="aspect-[11/16] w-full overflow-hidden rounded-lg sm:aspect-auto sm:h-64 sm:w-44 sm:opacity-0 lg:opacity-100">
                                                <img
                                                    src="/img/360-overview-hero-desktop.jpeg"
                                                    alt=""
                                                    className="h-full w-full object-cover object-center"
                                                />
                                            </div>
                                            <div className="aspect-[11/16] w-full overflow-hidden rounded-lg sm:aspect-auto sm:h-64 sm:w-44">
                                                <img
                                                    src="/img/sales-overview-products.png"
                                                    alt=""
                                                    className="h-full w-full object-cover object-center"
                                                />
                                            </div>
                                        </div>
                                        <div className="grid flex-shrink-0 grid-cols-1 gap-y-2 sm:gap-y-6 lg:gap-y-8">
                                            <div className="aspect-[11/16] w-full overflow-hidden rounded-lg sm:aspect-auto sm:h-64 sm:w-44">
                                                <img
                                                    src="/img/product-service.png"
                                                    alt=""
                                                    className="h-full w-full object-cover object-center"
                                                />
                                            </div>
                                            <div className="aspect-[11/16] w-full overflow-hidden rounded-lg sm:aspect-auto sm:h-64 sm:w-44">
                                                <img
                                                    src="/img/php-rc-card-1-2.png"
                                                    alt=""
                                                    className="h-full w-full object-cover object-center"
                                                />
                                            </div>
                                            <div className="aspect-[11/16] w-full overflow-hidden rounded-lg sm:aspect-auto sm:h-64 sm:w-44">
                                                <img
                                                    src="/img/salesforce/industry-cloud.jpeg"
                                                    alt=""
                                                    className="h-full w-full object-cover object-center"
                                                />
                                            </div>
                                        </div>
                                        <div className="grid flex-shrink-0 grid-cols-1 gap-y-2 sm:gap-y-6 lg:gap-y-8">
                                            <div className="aspect-[11/16] w-full overflow-hidden rounded-lg sm:aspect-auto sm:h-64 sm:w-44">
                                                <img
                                                    src="/img/hp-img-learn-salesforce.jpeg"
                                                    alt=""
                                                    className="h-full w-full object-cover object-center"
                                                />
                                            </div>
                                            <div className="aspect-[11/16] w-full overflow-hidden rounded-lg sm:aspect-auto sm:h-64 sm:w-44">
                                                <img
                                                    src="/img/gartner-82521-1268x714.jpeg"
                                                    alt=""
                                                    className="h-full w-full object-cover object-center"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <MoreButton />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureHead;
